import { Map } from "immutable";
import { HttpResult } from "widgets-for-react";
import { AvailableLanguages } from "../../../../utils";
import { WordPress } from "../../../wordpress/wordpress_api";
import { SimplePage } from "./Fc150Years.types";


export const get_pages_by_category = (lang: AvailableLanguages, categories: number[]): Promise<HttpResult<(WordPress.PageResponse & WordPress.EmbedData)[]>> =>
  fetch(`/${lang}/wp-json/wp/v2/pages?_embed=1&per_page=100${categories.length > 0 ? `&categories=${categories.reduce((xs, x) => xs + x + ',', '')}` : ''}`)
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      return Promise.reject(response.statusText)
    })
    .then(data => (<HttpResult<(WordPress.PageResponse & WordPress.EmbedData)[]>>{ kind: 'result', status: 200, value: data }))
    .catch(reason => {
      console.log(reason)
      return (<HttpResult<(WordPress.PageResponse & WordPress.EmbedData)[]>>{ kind: 'failed', status: 500 })
    })

export const get_stories_overview = (lang: AvailableLanguages, taxonomy: number, page: number): Promise<HttpResult<SimplePage<WordPress.StoryResponse[]>>> =>
  fetch(`/${lang}/wp-json/wp/v2/stories?categories=${taxonomy}&per_page=10&page=${page}`)
    .then(async response => {
      if (response.ok) {
        let data = await response.json()
        let total_pages = Number(response.headers.get('x-wp-totalpages'))
        return (<HttpResult<SimplePage<WordPress.StoryResponse[]>>>{kind: 'result', status: response.status, value: {
          entity: data, 
          total_pages: total_pages, 
          page: page, 
          taxonomy: taxonomy,
        }})
      }
      return Promise.reject(response.statusText)
    })
    .catch(reason => {
      console.log(reason)
      return (<HttpResult<SimplePage<WordPress.StoryResponse[]>>>{ kind: 'failed', status: reason })
    })


export const get_story_taxonomies = (lang: AvailableLanguages): Promise<HttpResult<Map<number, WordPress.TaxonomyResponse>>> =>
  fetch(`/${lang}/wp-json/wp/v2/categories`)
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      return Promise.reject(response.statusText)
    })
    .then((data: WordPress.TaxonomyResponse[]) => (<HttpResult<Map<number, WordPress.TaxonomyResponse>>>{ kind: 'result', status: 200, value: data.reduce((xs, x) => xs.set(x.id, x), Map()) }))
    .catch(reason => {
      console.log(reason)
      return (<HttpResult<Map<number, WordPress.TaxonomyResponse>>>{ kind: 'failed', status: reason })
    })



export const get_stories_by_ids = (lang: AvailableLanguages, ids: number[]): Promise<HttpResult<Map<number, WordPress.StoryResponse>>> =>
  fetch(`/${lang}/wp-json/wp/v2/stories/?${ids.reduce((xs, x) => xs + `include[]=${x}&`, '')}`)
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      return Promise.reject(response.statusText)
    })
    .then((data: WordPress.StoryResponse[]) => (<HttpResult<Map<number, WordPress.StoryResponse>>>{ kind: 'result', status: 200, value: data.reduce((xs, x) => xs.set(x.id, x), Map()) }))
    .catch(reason => {
      console.log(reason)
      return (<HttpResult<Map<number, WordPress.StoryResponse>>>{ kind: 'failed', status: reason })
    })